module.exports = __webpack_public_path__ + "img/pie-line-graph-desktop.11e051a2.svg";